// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cdd9g","memberContent":"styles_memberContent__Tgv7I","label":"styles_label__5k0YJ"};